import { version } from "./cvp_version_generated";
export const cvp_frontend_version = version;

console.log(
  `cvp_frontend_version ${cvp_frontend_version} loaded on ${window.location.href}`
);
